import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "I. Personal Information 個人情報", -1)
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_4 = { class: "col-span-full lg:col-span-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hidden col-span-8 lg:block" }, null, -1)
const _hoisted_6 = { class: "col-span-full lg:col-span-4" }
const _hoisted_7 = { class: "col-span-full lg:col-span-4" }
const _hoisted_8 = { class: "col-span-full lg:col-span-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_11 = { class: "col-span-full lg:col-span-6" }
const _hoisted_12 = { class: "col-span-full lg:col-span-6" }
const _hoisted_13 = { class: "col-span-full lg:col-span-6" }
const _hoisted_14 = { class: "col-span-full lg:col-span-6" }
const _hoisted_15 = { class: "col-span-full lg:col-span-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 mt-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-bold text-darkgray-800" }, "Current Delivery Address / 住所", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "If you wish to send to another address, please ask at the reception on the day of your appointment.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-xs text-darkgray-800" }, "ほかの送付先を希望する場合は当日レセプションに申し付けください。", -1)
const _hoisted_20 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_21 = { class: "col-span-full lg:col-span-6" }
const _hoisted_22 = { class: "col-span-full lg:col-span-6" }
const _hoisted_23 = { class: "col-span-full lg:col-span-6" }
const _hoisted_24 = { class: "col-span-full lg:col-span-6" }
const _hoisted_25 = { class: "col-span-full lg:col-span-6" }
const _hoisted_26 = { class: "col-span-full lg:col-span-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 mt-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_28 = { class: "grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_29 = { class: "col-span-full lg:col-span-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-bold" }, "No. of visits to our clinic/当センター受診回数:", -1)
const _hoisted_31 = { class: "space-y-2" }
const _hoisted_32 = { class: "col-span-full lg:col-span-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-bold" }, "Family hospitals and doctors/かかりつけの病院や医師:", -1)
const _hoisted_34 = { class: "space-y-2" }

import TextInput from '@/components/inputs/TextInput.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import patient from "@/classes/UserData";
import { ref } from 'vue';
import { numberonly } from "@/helpers/NumberHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInformation',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
    provinces: {
        type: Object,
        required: true
    },
    cities: {
        type: Object,
        required: true
    },
    barangays: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const gender = patient.getGender()
const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          id: "suffix",
          disabled: __props.disableInputs,
          modelValue: item.value.suffix,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.suffix) = $event)),
          type: "text",
          placeholder: "Suffix / サフィックス(ある場合のみ)",
          error: __props.errors['personal_information.suffix'] ? __props.errors['personal_information.suffix'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TextInput, {
          id: "last-name",
          disabled: __props.disableInputs,
          modelValue: item.value.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.last_name) = $event)),
          type: "text",
          placeholder: "Last Name / 姓",
          error: __props.errors['personal_information.first_name'] ? __props.errors['personal_information.first_name'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(TextInput, {
          id: "first-name",
          disabled: __props.disableInputs,
          modelValue: item.value.first_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.first_name) = $event)),
          type: "text",
          placeholder: "Given Name / 名",
          error: __props.errors['personal_information.first_name'] ? __props.errors['personal_information.first_name'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(TextInput, {
          id: "middle-name",
          disabled: __props.disableInputs,
          modelValue: item.value.middle_name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.middle_name) = $event)),
          type: "text",
          placeholder: "Middle Name / ミドルネーム(ある場合のみ"
        }, null, 8, ["disabled", "modelValue"])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createBlock(CalendarPicker, {
          disabled: __props.disableInputs,
          key: item.value.birthdate,
          modelValue: item.value.birthdate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.birthdate) = $event)),
          id: "date-of-birth_pi",
          inline: false,
          placeholder: "Date of Birth / 生年月日",
          error: __props.errors['personal_information.birthdate'] ? __props.errors['personal_information.birthdate'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(TextInput, {
          disabled: __props.disableInputs,
          add_on_left: true,
          add_on_text: "+63",
          onKeypress: _unref(numberonly),
          placeholder: 'Cellphone Number /携帯電話番号',
          maxlength: 10,
          modelValue: item.value.cellphone_number,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.cellphone_number) = $event)),
          error: __props.errors.cellphone_number ? __props.errors.cellphone_number[0] : ''
        }, null, 8, ["disabled", "onKeypress", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(MultiselectInput, {
          id: "province",
          disabled: __props.disableInputs,
          modelValue: item.value.sex,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((item.value.sex) = $event)),
          placeholder: "Sex / 性別",
          options: _unref(gender),
          error: __props.errors['personal_information.sex'] ? __props.errors['personal_information.sex'][0] : ''
        }, null, 8, ["disabled", "modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(TextInput, {
          id: "email",
          disabled: __props.disableInputs,
          modelValue: item.value.email_address,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((item.value.email_address) = $event)),
          type: "email",
          placeholder: "Email Address / E-mailアドレス",
          error: __props.errors['personal_information.email_address'] ? __props.errors['personal_information.email_address'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(TextInput, {
          id: "nationality",
          disabled: __props.disableInputs,
          modelValue: item.value.nationality,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((item.value.nationality) = $event)),
          type: "text",
          placeholder: "Nationality / 国籍",
          error: __props.errors['personal_information.nationality'] ? __props.errors['personal_information.nationality'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ])
    ]),
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(MultiselectInput, {
          disabled: __props.disableInputs,
          id: "province",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('clearCity'))),
          modelValue: item.value.province,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((item.value.province) = $event)),
          placeholder: "Province",
          options: __props.provinces,
          error: __props.errors['personal_information.province'] ? __props.errors['personal_information.province'][0] : ''
        }, null, 8, ["disabled", "modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(MultiselectInput, {
          id: "city",
          disabled: __props.disableInputs,
          modelValue: item.value.city,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((item.value.city) = $event)),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('clearBgy'))),
          placeholder: "City/Municipality",
          options: __props.cities,
          error: __props.errors['personal_information.city'] ? __props.errors['personal_information.city'][0] : ''
        }, null, 8, ["disabled", "modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(MultiselectInput, {
          disabled: __props.disableInputs,
          id: "barangay",
          modelValue: item.value.barangay,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((item.value.barangay) = $event)),
          placeholder: "Barangay",
          options: __props.barangays,
          error: __props.errors['personal_information.barangay'] ? __props.errors['personal_information.barangay'][0] : ''
        }, null, 8, ["disabled", "modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(TextInput, {
          disabled: __props.disableInputs,
          id: "street",
          modelValue: item.value.street,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((item.value.street) = $event)),
          type: "text",
          placeholder: "Street",
          error: __props.errors['personal_information.street'] ? __props.errors['personal_information.street'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(TextInput, {
          id: "bldg",
          disabled: __props.disableInputs,
          modelValue: item.value.building_number,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((item.value.building_number) = $event)),
          type: "text",
          placeholder: "No./Bldg."
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(TextInput, {
          disabled: __props.disableInputs,
          maxlength: 4,
          modelValue: item.value.zip_code,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((item.value.zip_code) = $event)),
          onKeypress: _cache[17] || (_cache[17] = ($event: any) => (_unref(numberonly)($event.target.value))),
          type: "text",
          placeholder: "ZIP Code"
        }, null, 8, ["disabled", "modelValue"])
      ])
    ]),
    _hoisted_27,
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createVNode(RadioGroup, {
            options: [
                            { id: 'first_time', label: '1st time/初めて', value: 'first_time'},
                            { id: 'two_or_more', label: '2 times or more/2回目以上', value: 'two_or_more'},
                        ],
            name: "number_of_clinic_visits",
            modelValue: item.value.number_of_clinic_visits,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((item.value.number_of_clinic_visits) = $event)),
            disabled: __props.disableInputs
          }, null, 8, ["modelValue", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createVNode(TextInput, {
            id: "family_hospital",
            type: "text",
            placeholder: "Hospital/病院",
            modelValue: item.value.family_hospital,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((item.value.family_hospital) = $event)),
            disabled: __props.disableInputs
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(TextInput, {
            id: "family_doctor",
            type: "text",
            placeholder: "Doctor/医師",
            modelValue: item.value.family_doctor,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((item.value.family_doctor) = $event)),
            disabled: __props.disableInputs
          }, null, 8, ["modelValue", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})